import dayjs from 'dayjs';
import { Coordinates } from '../coordinates.model';

export class UserEvent {
  public readonly type?: string;
  public readonly instant: dayjs.Dayjs;
  public readonly coordinates?: Coordinates;

  constructor(type?: string, instant?: dayjs.Dayjs, coordinates?: Coordinates) {
    this.type = type;
    this.coordinates = coordinates;
    this.instant = instant ?? dayjs();
  }
}
